const ACTIONS = {
  CHANGE_NAME: 'CHANGE_NAME',
  FETCH_PRODUCTS: 'FETCH_PRODUCTS',

  SIGN_IN: 'SIGIN_IN',
  SIGN_OUT: 'SIGN_OUT',
  GET_TOKEN: 'GET_TOKEN',
  GET_USER: 'GET_USER',

  GET_PROSPECTS: 'GET_PROSPECTS',

  // UTILS
  DEL_Edit: 'DEL_Edit',
  UPDATE_EDIT: 'UPDATE_EDIT',
  IS_SEARCH: 'IS_SEARCH',
  UPDATE_IS_VIEWED: 'UPDATE_IS_VIEWED',

  // ─────────────────────────────────────
  // ROOMS
  // ─────────────────────────────────────
  GET_ALL_ROOMS_REQUEST: 'GET_ALL_ROOMS_REQUEST',
  GET_ALL_ROOMS_SUCCESS: 'GET_ALL_ROOMS_SUCCESS',
  GET_ALL_ROOMS_FAIL: 'GET_ALL_ROOMS_FAIL',

  GET_SINGLE_ROOM_REQUEST: 'GET_SINGLE_ROOM_REQUEST',
  GET_SINGLE_ROOM_SUCCESS: 'GET_SINGLE_ROOM_SUCCESS',
  GET_SINGLE_ROOM_FAIL: 'GET_SINGLE_ROOM_FAIL',

  SEARCH_ROOMS_REQUEST: 'SEARCH_ROOMS_REQUEST',
  SEARCH_ROOMS_SUCCESS: 'SEARCH_ROOMS_SUCCESS',
  SEARCH_ROOMS_FAIL: 'SEARCH_ROOMS_FAIL',

  TOGGLE_STAR_ROOM: 'TOGGLE_STAR_ROOM',
  DELETE_ROOM: 'DELETE_ROOM',

  // ─────────────────────────────────────
  // THREADS
  // ─────────────────────────────────────
  GET_THREADS_REQUEST: 'GET_THREADS_REQUEST',
  GET_THREADS_SUCCESS: 'GET_THREADS_SUCCESS',
  GET_THREADS_FAIL: 'GET_THREADS_FAIL',

  // ─────────────────────────────────────
  // SEND MESSAGE
  // ─────────────────────────────────────
  SEND_MESSAGE_REQUEST: 'SEND_MESSAGE_REQUEST',
  SEND_MESSAGE_SUCCESS: 'SEND_MESSAGE_SUCCESS',
  SEND_MESSAGE_FAIL: 'SEND_MESSAGE_FAIL',

  SET_ACTIVE_PROSPECT: 'SET_ACTIVE_PROSPECT',

  SET_RESPONSIVE: 'SET_RESPONSIVE',
  SET_MOBILE_VIEW: 'SET_MOBILE_VIEW',
};
export default ACTIONS;
